import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'react-inv-forms';
import { useTranslation } from 'react-i18next';
import fingerPrintIcon from '../../../images/fingerPrintIcon.svg';
import { notification, Popconfirm } from 'antd';
import { Input } from 'react-inv-forms';

export interface Props {
  /** stan ładowania modala */
  loading: boolean;
  /** stan błędu */
  error: boolean;
  /** stan otwarcia modala */
  opened: boolean;
  /** callback wykonywany na przycisku "Potwierdź" */
  confirm: (code: string, mode: 'sms' | 'email') => void;
  /** callback wykonywany na przycisku "Anuluj" */
  close: () => void;
  /** tryb modala - dostępny tryb 'sms' i 'email'*/
  mode: 'sms' | 'email';
  /** opcjonalny parametr do przekazania klucza translacji do tytułu modala */
  titleTranslationKey?: string;
}
// klucze translacji dla trybów
export const translations = {
  sms: {
    title: 'INPUT_CODE_SMS_TITLE_MODAL',
    okText: 'CONFIRM',
  },
  email: {
    title: 'INPUT_CODE_EMAIL_TITLE_MODAL',
    okText: 'CONFIRM',
  },
};
/**
 * Komponent modala podpisu ocen
 *
 */
export const InputCodeModal: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { loading, opened, mode = 'sms', close, confirm } = props;
  const codeInput = useRef<any>();
  useEffect(() => {
    setTimeout(() => {
      if (opened) {
        codeInput.current.focus();
      }
    }, 200);
    // }
  }, [opened]);
  const [code, setCode] = useState('');
  const onOk = (): void => {
    confirm(code, mode);
    setCode('');
  };
  const validateInput = (): void => {
    if (isNaN(Number(code))) {
      notification.warn({
        message: t('SIGN_MARKS_MODAL_INCORRECT_VALUE'),
        top: 100,
      });
    } else if (code.length !== 6) {
      notification.warn({
        message: t('SIGN_MARKS_MODAL_INCORRECT_LENGTH'),
        top: 100,
      });
    } else {
      onOk();
    }
  };
  const cancelWithConfirm = (
    <Popconfirm
      id='inputCodeModalPopconfirm'
      title={t('SIGN_MARKS_MODAL_ARE_YOU_SURE')}
      okText={t('YES')}
      cancelText={t('NO')}
      overlayClassName='custom_popconfirm'
      onConfirm={(): void => {
        setCode('');
        close();
      }}
    >
      <a>{t('CANCEL')}</a>
    </Popconfirm>
  );
  return (
    <Modal
      visible={opened}
      okText={t(translations[mode].okText)}
      cancelText={cancelWithConfirm}
      confirmLoading={loading}
      title={
        <span>
          <img alt='finger print icon' src={fingerPrintIcon} />
          {t(props.titleTranslationKey ? props.titleTranslationKey : translations[mode].title)}
        </span>
      }
      maskClosable={false}
      closable={false}
      onOk={validateInput}
      onCancel={setCode.bind(null, '')}
      okButtonProps={!code.length ? { disabled: true, autoFocus: false } : {}}
      className='cyInputCodeModal'
    >
      <Input
        value={code}
        placeholder={t(translations[mode].title)}
        autoFocus
        maxLength={6}
        minLength={6}
        onPressEnter={validateInput}
        onChange={(e: any): void => setCode(e.target.value)}
        ref={codeInput}
        data-cy='inputSmsCode'
      />
    </Modal>
  );
};

export default InputCodeModal;
